var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_299_17436)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82621 4L2.9082 7.14844H2.95083L4.03079 4H4.85903L3.39337 8H2.46363L1 4H1.82621Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15975 4V8H5.40662V4H6.15975Z",
    fill: "#565656"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9753 8V4H8.53434C8.85373 4 9.12169 4.05729 9.33822 4.17187C9.55611 4.28646 9.72054 4.44401 9.83151 4.64453C9.94384 4.84375 10 5.07031 10 5.32422C10 5.58073 9.94384 5.80859 9.83151 6.00781C9.71918 6.20703 9.5534 6.36393 9.33416 6.47852C9.11492 6.5918 8.84493 6.64844 8.52419 6.64844H7.49092V6.05273H8.42269C8.60945 6.05273 8.76238 6.02148 8.88147 5.95898C9.00056 5.89648 9.08853 5.81055 9.14537 5.70117C9.20356 5.5918 9.23266 5.46615 9.23266 5.32422C9.23266 5.18229 9.20356 5.05729 9.14537 4.94922C9.08853 4.84115 8.99989 4.75716 8.87944 4.69727C8.76035 4.63607 8.60674 4.60547 8.41863 4.60547H7.72843V8H6.9753Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_17436",
    x1: 6,
    y1: -2.16,
    x2: 6,
    y2: 13.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg12);
export default __webpack_public_path__ + "static/media/img12.7a76b75e936ea35aa62472f42c4770d5.svg";
export { ForwardRef as ReactComponent };